<i *ngIf="this.modalType === 'patient-row'" [class]="iconClass" (click)="openThreadDialog()"></i>
<i *ngIf="this.modalType === 'thread'" [class]="iconClass" (click)="openThreadDialog()"></i>